import { Helmet } from 'react-helmet';
import OrderDetail
  from 'src/components/order-detail/OrderDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import OrderListToolbar from '../components/order-detail/OrderToolbar';

const Order = () => (
  <>
    <Helmet>
      <title>Quản lý đơn hàng</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <OrderListToolbar />
        <Box sx={{ pt: 3 }}>
          <OrderDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Order;
